import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { reverseGeocode } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";

const dist = (a, b) => {
  const r = 6371000;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const x = Math.sin(dLat / 2) ** 2 + Math.cos((a.lat * Math.PI) / 180) * Math.cos((b.lat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2;
  return 2 * r * Math.asin(Math.sqrt(x));
};

export default function GpsTracker() {
  const { setUser } = useAuth();
  const last = useRef({ at: 0, pos: null, geo: null });

  useEffect(() => {
    if (!navigator.geolocation) return undefined;
    const id = navigator.geolocation.watchPosition(async (p) => {
      const pos = { lat: p.coords.latitude, lng: p.coords.longitude };
      const l = last.current;
      const moved = l.pos ? dist(l.pos, pos) : Infinity;
      if (Date.now() - l.at < 3000 || moved < 10) return;
      l.at = Date.now();
      l.pos = pos;
      let label;
      if (!l.geo || dist(l.geo, pos) > 500) {
        l.geo = pos;
        label = await reverseGeocode(pos.lat, pos.lng);
      }
      try {
        const { data } = await api.put("/me/location", { ...pos, label });
        setUser((u) => (u ? { ...u, location: data.location } : u));
      } catch (e) {
        l.at = 0;
      }
    }, () => {}, { enableHighAccuracy: true, maximumAge: 2000, timeout: 15000 });
    return () => navigator.geolocation.clearWatch(id);
  }, [setUser]);

  return null;
}
